import React from "react";
import { Typography, Space, Card, Divider, Image } from "antd";
import ConnectingDots from "@assets/KPMG/connectingDots.svg";
import CircleInCircle from "@assets/KPMG/circleInCircle.svg";
import { Icon } from "@iconify/react";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

export const ProjectsCard = (props: any) => {
  const { data, index, color } = props;
  const navigate = useNavigate();
  const TextColor = color ? "#1E49E2" : "#636363";
  return (
    <Card
      bodyStyle={{ padding: 0 }}
      style={{
        width: "100%",
        borderRadius: "15px",
        height: "100%",
      }}
    >
      <Fade direction="up" triggerOnce cascade={true} damping={0.1}>
        <div
          style={{
            marginTop: 10,
            marginRight: 10,
            position: "relative",
          }}
        >
          <img
            src={data.image}
            style={{
              padding: 0,
              width: "100%",
              objectFit: "cover",
              borderTopRightRadius: 20,
              height: 180,
            }}
          />
         {data.source === "KPMG Intelligence" && (
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "rgba(255, 255, 255, 0.5)", 
                borderRadius: "10px", 
                padding: "8px", 
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                icon="mdi:star" 
                style={{
                  fontSize: "40px", 
                  color: "#1E49E2", 
                }}
              />
            </div>
          )}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              background: "#FD349C",
              padding: "4px 8px",
              borderTopRightRadius: 50,
            }}
          >
            <div
              className="ratingContainer"
              style={{
                paddingRight: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{ color: "#fff", textAlign: "right" }}
                className="textSmall"
              >
                <div style={{ lineHeight: "initial" }}>Investable</div>
                <div style={{ lineHeight: "initial" }}>Rating</div>
              </div>
              <Divider
                type="vertical"
                style={{
                  height: 36,
                  border: "1px solid #fff",
                  margin: "0 10px",
                }}
              />
              <div style={{ display: "flex", color: "#fff" }}>
                <div>
                  <strong>{data.InvestableRating}</strong>
                </div>
                <div className="textSmall">/100</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: 15, paddingBottom: 0 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: data.SupportLink ? "90%" : "100%" }}>
              <Typography.Title
                style={{
                  cursor:
                    data.SupportLink || data.description
                      ? "pointer"
                      : "default",
                  marginBottom: 0,
                }}
                level={5}
                onClick={() => {
                  // if (data.SupportLink) {
                  //   window.open(data.SupportLink);
                  // } else if (data.description) {
                  //   navigate(`/investment-hub/view/${data.key}`);
                  // }
                  navigate(`/investment-hub/view/${data.key}`);
                }}
                ellipsis
                title={data.title}
              >
                {data.title}
              </Typography.Title>
            </div>
            {data.SupportLink && (
              <div style={{ width: "10%", textAlign: "right" }}>
                <Icon
                  icon={"tabler:external-link"}
                  fontSize={15}
                  color="#003087"
                  style={{cursor : "pointer"}}
                  onClick={() => {
                    window.open(data.SupportLink);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Fade>
      <div style={{ padding: "20px 10px" }}>
        <Space direction="vertical">
          <Fade direction="up" triggerOnce cascade={true} damping={0.1}>
            <Space>
              <Icon icon={"codicon:location"} fontSize={15} color="#003087" />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                Location:{" "}
                <strong style={{ color: TextColor }}>
                  {data.City && <span>{data.City},</span>} {data.Location}
                </strong>
              </Typography.Text>
            </Space>
            <Space>
              <Icon icon={"iconoir:coins"} fontSize={15} color="#003087" />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                Estimated Project Cost:{" "}
                <strong style={{ color: TextColor }}>
                  {data.EstimatedProjectCost}{" "}
                </strong>
              </Typography.Text>
            </Space>
            {/* <Space>
                <Icon
                  icon={"uil:percentage"}
                  fontSize={15}
                  color="#003087"
                />
                <Typography.Text
                  style={{ fontSize: 13, color: "#636363" }}
                >
                  {" "}
                  Investable Rating:
                  <strong> {data.InvestableRating}</strong>
                </Typography.Text>
              </Space> */}
            {/* <Space>
              <Image
                src={ConnectingDots}
                // fontSize={15}
                preview={false}
                color="#003087"
              />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                {" "}
                Tech Involved:{" "}
                <strong style={{ color: TextColor }}>
                  {data.TechInvolved}
                </strong>
              </Typography.Text>
            </Space> */}
            <Space>
              <Image src={CircleInCircle} preview={false} color="#003087" />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                {" "}
                Stage/Type:{" "}
                <strong style={{ color: TextColor }}>
                  {" "}
                  {data.ProjectStage}{" "}
                </strong>
              </Typography.Text>
            </Space>
            <Space>
              <Icon
                icon={"ic:outline-star-border"}
                fontSize={15}
                color="#003087"
              />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                {" "}
                Financing Options:{" "}
                <strong style={{ color: TextColor }}>{data.ESGRating}</strong>
              </Typography.Text>
            </Space>
            <Space>
              <Image src={CircleInCircle} preview={false} color="#003087" />
              <Typography.Text style={{ fontSize: 13, color: "#636363" }}>
                {" "}
                Sector:{" "}
                <strong style={{ color: TextColor }}>
                  {" "}
                  {data.categories[0].subcategories[0]},{" "}
                  {data.categories[0].name}
                </strong>
              </Typography.Text>
            </Space>
          </Fade>
        </Space>
        {/* <div style={{ textAlign: 'right', margin: '0.5rem 0 0 0' }}>
                                            <Button size="small" onClick={() => navigate('/detail-view')} style={{ padding: '0.7rem' }}>
                                                Details
                                            </Button>
                                        </div> */}
      </div>
    </Card>
  );
};
